import type { Manager } from '@jane/business-admin/types';

const TEMPORARY_USER_ID = 'GUEST_MANAGER';

const resolveOrganizationId = (
  manager: Manager,
  selectedOrgId?: number | null
): number | undefined => {
  if (manager.internal) {
    return selectedOrgId ?? undefined;
  }

  return manager.organization_id ?? undefined;
};

export const getManagerFlagContext = (
  manager?: Manager,
  storeId?: number,
  organizationId?: number | null
) => {
  const flagManager = { key: TEMPORARY_USER_ID, anonymous: true };

  if (manager?.id) {
    return {
      anonymous: false,
      key: manager?.id.toString(),
      kind: 'user',
      firstName: manager?.first_name,
      lastName: manager?.last_name,
      email: manager?.email,
      role: manager?.role,
      permissions: manager?.permissions,
      stores: manager?.internal ? [] : manager?.stores,
      internal: manager?.internal ? 'internal' : 'external',
      storeId,
      organizationId: resolveOrganizationId(manager, organizationId),
    };
  }
  return flagManager;
};
